import { EmptyValuePlaceholder } from "@/components/ui"
import { SingleLineAddressOnListing } from '@/components/Address'
import { capitalize } from '@/utils/strings'
import { formatPrice, formatSurface} from '@/utils/formatters'

export default ({ bien }) => {
  const handleRowClick = (bienId) => {
    window.location.href = `/extranet/proprietaire/biens/${bienId}` // Rediriger vers la page de détails du bien cliqué
  }

  // Fonction pour obtenir les prix selon les mandats
  const getPrixByMandats = () => {
    if (!bien.mandats_data || bien.mandats_data.length === 0) {
      return <EmptyValuePlaceholder />
    }

    if (bien.mandats_data.length === 1) {
      const mandat = bien.mandats_data[0]
      return <EmptyValuePlaceholder value={mandat.type_mandat === "vente" ? formatPrice(bien.prix_vente) : ""}/>
    }

    // Cas de plusieurs mandats : afficher les deux prix
    return (
      <div className='flex flex-col'>
        {bien.mandats_data.map((mandat, i) => (
          <div key={i}>
            <EmptyValuePlaceholder value={mandat.type_mandat === "vente" ? formatPrice(bien.prix_vente) : ""} />
          </div>
        ))}
      </div>
    )
  }

  // Fonction pour obtenir les honoraires selon les mandats
  const getHonorairesByMandats = () => {
    if (!bien.mandats_data || bien.mandats_data.length === 0) {
      return <EmptyValuePlaceholder />
    }

    if (bien.mandats_data.length === 1) {
      const mandat = bien.mandats_data[0]
      return <EmptyValuePlaceholder value={mandat.type_mandat === "vente" ? formatPrice(bien.montant_honoraires_ttc) : ""}/>
    }

    // Cas de plusieurs mandats : afficher les deux honoraires
    return (
      <div className='flex flex-col'>
        {bien.mandats_data.map((mandat, i) => (
          <div key={i}>
            <EmptyValuePlaceholder value={mandat.type_mandat === "vente" ? formatPrice(bien.montant_honoraires_ttc) : ""}/>
          </div>
        ))}
      </div>
    )
  }

  return (
    <tr onClick={() => handleRowClick(bien.id)}
        data-object="bien" data-id={bien.id}
        className={`cursor-pointer hover:bg-primary-200 transition-all duration-500`}
    >
      <td>
        <div className={`flex items-center`}>
          { bien.type_mandats?.length < 2 && <EmptyValuePlaceholder value={bien.type_mandats[0]} className='capitalize'/>  }
          { bien.type_mandats?.length > 1 &&
              <div className='flex flex-col'>{
                bien.type_mandats.map((mandat, i) => <div key={i} className="capitalize">{mandat}</div>)
              }</div>
          }
        </div>
      </td>
      <td><EmptyValuePlaceholder value={getPrixByMandats()} /></td>
      <td><EmptyValuePlaceholder value={getHonorairesByMandats()} /></td>
      <td>
        <SingleLineAddressOnListing data={bien} /> 
      </td>
      <td><EmptyValuePlaceholder value={capitalize(bien.type_bien)} /></td>
      <td><EmptyValuePlaceholder value={formatSurface(bien.surface_carrez)} /></td>
    </tr>
  )
}